module.exports = __webpack_public_path__ + "static/Gill-600373fa8895225ce568abdb6ecbe28b.jpg";